import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "./auth.service";
import * as alertify from "alertifyjs";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private route: Router,
    private authService: AuthService
  ) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMessage = 'An unknown error occurred!';
                let errorCode = error.status;

                if (error.error) {
                    // Check if error has a message from backend
                    if (typeof error.error === 'string') {
                        errorMessage = error.error; // Plain text response
                    } else if (error.error.message) {
                        errorMessage = error.error.message; // JSON with message property
                    } else if (error.error.error) {
                        errorMessage = error.error.error; // JSON with error property
                    }
                }
                // Handle specific errors
                // if (error.status === 401) {
                //     // this.router.navigate(['/login']);
                // } else if (error.status === 403) {
                //     // this.router.navigate(['/forbidden']);
                // }

                // Handle specific errors
                switch(errorCode) {
                    case 0: 
                        errorMessage = "Failed to reach server";
                        break;
                    default:
                        break;
                }

                // return throwError(() => errorMessage);
                return throwError(() => new Error(`${errorMessage}`));
            })
        );
    }
}
